import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone } from 'lucide-react';
import { clinicInfo } from '../data/mock';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  const scrollToSection = (sectionId) => {
    if (location.pathname !== '/') {
      window.location.href = `/#${sectionId}`;
    } else {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
    setMobileMenuOpen(false);
  };

  return (
    <header className="navigation-header">
      <div className="container" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0 40px' }}>
        <Link to="/" className="navigation-logo">
          OdontoDentine
        </Link>

        {/* Desktop Navigation */}
        <nav className="navigation-menu" style={{ display: mobileMenuOpen ? 'none' : 'flex' }}>
          <Link 
            to="/" 
            className={`navigation-link ${isActive('/') ? 'active' : ''}`}
          >
            Início
          </Link>
          <Link 
            to="/sobre" 
            className={`navigation-link ${isActive('/sobre') ? 'active' : ''}`}
          >
            Sobre Nós
          </Link>
          <Link 
            to="/tratamentos" 
            className={`navigation-link ${isActive('/tratamentos') ? 'active' : ''}`}
          >
            Tratamentos
          </Link>
          <Link 
            to="/contato" 
            className={`navigation-link ${isActive('/contato') ? 'active' : ''}`}
          >
            Contato
          </Link>
        </nav>

        <div className="navigation-utilities">
          <a 
            href={`https://wa.me/${clinicInfo.phone.replace(/[^0-9]/g, '')}`}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-primary"
            style={{ display: mobileMenuOpen ? 'none' : 'inline-flex' }}
          >
            Agendar Avaliação
          </a>
          
          <button 
            className="mobile-menu-toggle"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            style={{
              display: 'none',
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              padding: '8px'
            }}
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="mobile-menu" style={{
          position: 'absolute',
          top: '100%',
          left: 0,
          right: 0,
          background: 'var(--bg-primary)',
          borderBottom: '1px solid var(--border-light)',
          padding: '20px 40px',
          display: 'flex',
          flexDirection: 'column',
          gap: '16px'
        }}>
          <Link 
            to="/" 
            className="navigation-link"
            onClick={() => setMobileMenuOpen(false)}
          >
            Início
          </Link>
          <Link 
            to="/sobre" 
            className="navigation-link"
            onClick={() => setMobileMenuOpen(false)}
          >
            Sobre Nós
          </Link>
          <Link 
            to="/tratamentos" 
            className="navigation-link"
            onClick={() => setMobileMenuOpen(false)}
          >
            Tratamentos
          </Link>
          <Link 
            to="/contato" 
            className="navigation-link"
            onClick={() => setMobileMenuOpen(false)}
          >
            Contato
          </Link>
          <a 
            href={`https://wa.me/${clinicInfo.phone.replace(/[^0-9]/g, '')}`}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-primary"
            style={{ marginTop: '8px' }}
          >
            Agendar Avaliação
          </a>
        </div>
      )}
    </header>
  );
};

export default Header;